import * as React from 'react';
import { ISearchResult } from '../../state-helpers/search-results';
import { IPage } from '../../state-helpers/page';
import { getRangeCenteredAt } from '../../../global/functions/math';
import * as _ from 'lodash';
import { IPaginationOptions } from './pagination';
import { addUrlProps, UrlQueryParamTypes } from 'react-url-query';
import { setPage } from '../../actions/index';
import { connect } from 'react-redux';

import { PageButton, IPageButton, IPageNumber } from './page-button'

export interface IProps {
    numberOfButtonsToShow: number;
    paging: IPaginationOptions;
    onPageSelect(page: number): void;
}

export interface IState {

}

/// <summary>
/// Creates and renders collection of page buttons
/// </summary>
export class Paging extends React.Component<IProps, IState> {

    /// <summary>
    /// Creates collection of page buttons to render
    /// </summary>
    /// <returns>Page buttons</returns>
    get pages() {
        const numberOfPages = this.props.paging.totalPages;
        const pagesMiddle = Math.ceil(this.props.numberOfButtonsToShow / 2);

        //Create list of page number objects
        var pageNumbers = [];
        for (var i = 0; i < (numberOfPages); i++) {
            pageNumbers[i] = { number: i + 1, active: (i + 1) === this.props.paging.currentPage } as IPageNumber;
        }

        //Filter list to only the numbers we will display
        const centered = getRangeCenteredAt(this.props.paging.currentPage, this.props.numberOfButtonsToShow, pageNumbers);

        return centered.map((page, i) => {
            //Calculate page-specific attributes
            const isLeftMost = i === 0 && page.number !== 1;
            const isRightMost = page.number !== numberOfPages && page.number !== (numberOfPages - 1) && (i === centered.length - 1);

            const isLeftEllipsis = ((numberOfPages > this.props.numberOfButtonsToShow) && (this.props.paging.currentPage > pagesMiddle)) && i === 1;
            const isRightEllipsis = ((numberOfPages > this.props.numberOfButtonsToShow) && ((numberOfPages - this.props.paging.currentPage) > pagesMiddle)) && i === centered.length - 2;
            const isEllipsis = isLeftEllipsis || isRightEllipsis;

            const number = isLeftMost ? 1
                : isRightMost ? numberOfPages
                    : page.number;

            return _.assign(page, {
                isLeftMost,
                isRightMost,
                number,
                numberOfPages,
                isEllipsis
            }) as IPageButton;
        });
    }

    render() {
        return (
            <div className="search-pagination-buttons" data-id="pageLinks">
                {this.pages.map(this.renderPageButton)}
            </div>
        );
    }

    renderPageButton = (page: IPageButton, index: number) => {
        return (
            <PageButton
                key={index}
                page={page}
                onPageSelect={this.props.onPageSelect} />
        )
    }
}

